import React from 'react';
import { Dropdown, Modal } from 'antd';
import { LogOut, UserRound } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Auth0Logout, imageLink } from '../../Constant/Utils';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar';
import { cn } from '../../lib/utils';

export function confirmArtistLogout() {
  Modal.confirm({
    title: 'Log out?',
    content: 'You will need to sign in again to access your dashboard and campaigns.',
    okText: 'Log out',
    cancelText: 'Cancel',
    okButtonProps: { danger: true },
    centered: true,
    onOk: () => Auth0Logout(),
  });
}

function initialsFromName(name) {
  const parts = (name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length === 0) return 'A';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}

function ArtistTopbarUserMenu() {
  const navigate = useNavigate();
  const user = useSelector(e => e.authenticationSlice.user);
  const auth0User = useSelector(e => e.authenticationSlice.auth0User);
  const avatarSrc = imageLink(user?.image || auth0User?.picture);
  const displayName = user?.name || auth0User?.name || 'Artist';

  const menuItems = [
    {
      key: 'account',
      label: (
        <span className="inline-flex items-center gap-2">
          <UserRound size={16} aria-hidden />
          Account overview
        </span>
      ),
      onClick: () => navigate('/dashboard/account-overview'),
    },
    { type: 'divider' },
    {
      key: 'logout',
      label: (
        <span className="inline-flex items-center gap-2">
          <LogOut size={16} aria-hidden />
          Log out
        </span>
      ),
      danger: true,
      onClick: () => confirmArtistLogout(),
    },
  ];

  return (
    <Dropdown
      overlayClassName="dropdownSideBar app-topbar-user-menu"
      menu={{ items: menuItems }}
      trigger={['click']}
      placement="bottomRight"
    >
      <button
        type="button"
        className={cn(
          'app-topbar-avatar-btn inline-flex h-9 w-9 shrink-0 items-center justify-center',
          'overflow-hidden rounded-full border border-sp-line bg-sp-surface p-0',
          'transition-[border-color,box-shadow] duration-sp ease-sp',
          'hover:border-sp-blue/40 hover:shadow-[0_0_0_3px_rgb(var(--sp-blue-rgb)/0.12)]',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sp-blue focus-visible:ring-offset-2'
        )}
        aria-label={`Account menu for ${displayName}`}
      >
        <Avatar className="h-9 w-9 shrink-0">
          <AvatarImage src={avatarSrc} alt="" className="object-cover" />
          <AvatarFallback className="bg-sp-blue-tint text-xs font-semibold text-sp-blue">
            {initialsFromName(displayName)}
          </AvatarFallback>
        </Avatar>
      </button>
    </Dropdown>
  );
}

export default ArtistTopbarUserMenu;
